var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgExpiredQuoteStatusIcon = function SvgExpiredQuoteStatusIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#7200CC",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7200CC",
    stroke: "#7200CC",
    strokeWidth: 0.2,
    d: "M26.835 19.62v-.1h-1.591v5.788h-3.796V26.9h5.387z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7200CC",
    stroke: "#7200CC",
    strokeWidth: 0.2,
    d: "M25.935 34.378a8.443 8.443 0 1 1 8.443-8.443 9 9 0 0 1-.045.921 5.795 5.795 0 0 0-7.477 7.477 9 9 0 0 1-.92.045Zm9.879-6.689a10.034 10.034 0 1 0-8.125 8.125 5.798 5.798 0 1 0 8.125-8.125Zm-3.52 8.813a4.209 4.209 0 1 1-.005-8.417 4.209 4.209 0 0 1 .006 8.417h-.002Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7200CC",
    d: "M32.991 29.309h-1.39v4.348h1.39zm0 4.87h-1.39v1.333h1.39z"
  })));
};
export { SvgExpiredQuoteStatusIcon as ReactComponent };
export default "/_next/static/media/_/_/packages/frontend/components/QuoteStatus/assets/expired-quote-status-icon.6c43028370a94d52bf7be83efbf8a8e8.svg";